import { Box, Button, Popover } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { PATH, setFilters } from "../../../router-path";

export interface AssetIdBreakdownProps {
	title: string;
	breakdown: Record<string, string>;
}

const styles = {
	box: {
		display: "flex",
		flexDirection: "column",
		gap: "8px",
		padding: "8px",
		maxHeight: "200px",
		overflowY: "auto",
	},
	singleBox: {
		display: "inline-flex",
		flexDirection: "row",
		gap: "16px",
		justifyContent: "flex-start",
	},
};

export function AssetIdBreakdown(props: Readonly<AssetIdBreakdownProps>) {
	const navigate = useNavigate();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	return (
		<>
			<Button onClick={handleClick} data-testid={props.title}>
				{props.title}
			</Button>
			<Popover
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<Box sx={styles.box}>
					{Object.keys(props.breakdown).map((key) => (
						<Box key={key} sx={styles.singleBox} data-testid={key}>
							<Link
								to={{
									pathname: PATH.SITES,
								}}
								onClick={(e) => {
									e.preventDefault();
									navigate(
										PATH.SITES,
										setFilters({
											searchValue: props.breakdown[key],
										})
									);
								}}
							>
								{key}
							</Link>
						</Box>
					))}
				</Box>
			</Popover>
		</>
	);
}
